export const SET_ACCOUNT = "account/SET_ACCOUNT";
export const REMOVE_ACCOUNT = "account/REMOVE_ACCOUNT";
export const SET_ACCOUNT_ERROR = "account/SET_ACCOUNT_ERROR";
export const CLEAR_ACCOUNT_ERROR = "account/CLEAR_ACCOUNT_ERROR";

export type AccountActionTypes =
    | {type: typeof SET_ACCOUNT; payload: Account }
    | {type: typeof REMOVE_ACCOUNT }
    | {type: typeof SET_ACCOUNT_ERROR; payload: string }
    | {type: typeof CLEAR_ACCOUNT_ERROR };

export type Account = {
    url: string,
    port: string,
    username: string,
    password: string
}

export type AccountState = {
    data?: Account;
    error?: string;
}

export interface AccountContextType {
    data?: Account;
    error?: string;
    createAccount: (account: Account) => void;
    removeAccount: () => void;
}

export const initialAccountContextType: AccountContextType = {
    data: undefined,
    error: undefined,
    createAccount: () => {},
    removeAccount: () => {}
};
